import React from 'react';

export default ({CodeSnippet}) => {
	return (
        <div className="grid-container contained mt4 mb4 mt12--lg mb12--lg center__form" dangerouslySetInnerHTML={{__html: CodeSnippet.code }}></div>
	);
};
